import { render, staticRenderFns } from "./changearchival.vue?vue&type=template&id=4c137074&scoped=true&"
import script from "./changearchival.vue?vue&type=script&lang=js&"
export * from "./changearchival.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./changearchival.vue?vue&type=style&index=1&id=4c137074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c137074",
  null
  
)

export default component.exports